import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ModelComparisonState = {
  isRunningModelComparisonOutput: boolean | null;
  updateIsRunningModelComparisonOutput: (isRunning: boolean | null) => void;
};

const useModelComparisonStore = create<ModelComparisonState>()(
  devtools(
    (set) => ({
      isRunningModelComparisonOutput: null,
      updateIsRunningModelComparisonOutput: (isRunningModelComparisonOutput) =>
        set(() => ({ isRunningModelComparisonOutput })),
    }),
    { name: 'modelComparisonStore' }
  )
);

export const useModelComparisonState = () =>
  useModelComparisonStore((state) => ({
    isRunningModelComparisonOutput: state.isRunningModelComparisonOutput,
  }));

export const useModelComparisonActions = () =>
  useModelComparisonStore((state) => ({
    updateIsRunningModelComparisonOutput:
      state.updateIsRunningModelComparisonOutput,
  }));

export default useModelComparisonStore;
